import { send } from 'vite';

const en = {
  seo: {
    // eslint-disable-next-line max-len
    keywords: 'BiliBili,free anime,anime,Top Anime,BL,GL,wetv,iqiyi,crunchyroll,Demon Slayer: Kimetsu no Yaiba,Attack on Titan,That Time I Got Reincarnated as a Slime (2nd season),Fly Me to the Moon,Mushoku Tensei: Isekai Ittara Honki Dasu,Heaven Official\'s Blessing,cosplay,SubThai',
  },
  common: {
    more: 'More',
    confirm: 'Confirm',
    cancel: 'Cancel',
    home: 'Home',
    clickToMove: 'Click to move'
  },
  follow: {
    follow: 'Follow',
    following: 'Following',
  },
  roomInfo: {
    share: 'Share',
    copySucceed: 'Link copied',
    copyFailed: 'Failed to copy the link',
    liveClosed: 'The livestreaming hasn\'t started yet',
    viewer: '0 viewer | 1 viewer | {count} viewers',
  },
  roomVideo: {
    controlBar: {
      play: 'Play',
      pause: 'Pause',
      refresh: 'Refresh',
      refreshSucceed: 'Refreshed',
      refreshFailed: 'Refresh Failed',
      refreshing: 'Refreshing',
      fullscreen: 'Landscape Mode',
      exitFullscreen: 'Exit Landscape Mode',
      switchQning: 'Switching quality to',
      switchQnFailed: 'Failed to switch quality, please retry',
      switchQnSucceed: 'Switched quality to',
    },
  },
  comment: {
    title: 'Danmaku',
    sender_input_placeholder: 'Send a Danmaku~',
    sended_send: 'Send',
    new_messages: '1 new Danmaku | {count} new Danmaku',
    login_before_send: 'Sign in to interact with other users through Danmaku',
    // eslint-disable-next-line max-len
    default_welcome: 'Welcome to the live streaming studio! We encourage innovative and diversified contents. At the same time, we will take necessary measures to prevent and stop any contents that violate laws and regulations, local regulatory requirements or ethical codes, or infringe on the legitimate rights and interests of others, or that may affect the safety and health of the community from spreading in the community. In addition, such violations may be reported to the regulatory authority in accordance with applicable laws and regulations'
  },
  rank: {
    title: 'Contributors Ranking',
    login: 'Log in',
    viewRank: ' to check your ranking',
    toContribute: 'Send Star gifts to bring you on the list',
    myScore: 'Contribution Points',
    noData: 'Support your favorite livestreamers to be listed as a major contributor!',
  },
  gift: {
    all: 'All',
    topUp: 'Top Up',
    top: 'Top',
    starDesc: 'Users can purchase Stars, and exchange them for gift items that can be counted as livestreamers\' earnings.',
  },
  introduction: {
    title: 'Livestream Introduction',
  },
  balance: {
    insufficientTitle: 'Insufficient Stars',
    insufficientContent: 'Star balance is insufficient, please top up',
    buy: 'Top up',
  },
  payment: {
    title: 'Top up Stars',
    balance: 'My Stars',
    next: 'Pay Now',
    agree: 'By tapping Pay Now, you agree to the ',
    agreement: 'Star Topping-up Agreement',
    repay: 'Repay',
    getPaid: 'Get Paid',
    orderTitle: 'Complete the payment on the page you are being redirected to.',
    exchangeRateDesc: 'The purchase price of Stars is subject to fluctuations in the exchange rate and changes in payment channels.',
    methodTitle: 'Select Payment Mehtod',
    // eslint-disable-next-line max-len
    orderDesc: 'Do not close this window before the payment is complete. After you complete the payment, tap either of the following buttons as needed.',
    toast_success: 'Topping up succeeded',
    toast_fail: 'Failed to top up',
    toast_notPay: 'Topping up incomplete',
    toast_cancel: 'Topping up cancelled',
    toast_timeout: 'Topping up timeout',
  },
  home: {
    live: 'LIVE',
    liveNow: 'LIVE',
    refresh: 'Refresh',
    refreshFailed: 'Failed to refresh, please try again',
    loadMore: 'Load more...',
    noMore: 'No more content',
    clickToLive: 'Click to live'
  },
  userCard: {
    followers: '0 Follower | 1 Follower | {count} Followers',
    videos: '0 Video | 1 Video | {count} Videos',
    promote: 'Set the user as the Admin',
    demote: 'Remove this Admin',
    mute: 'Block the user',
    unmute: 'Unblock the user',
  },
  modals: {
    muteConfirm: 'Blocked user will be unable to send Danmaku. Are you sure to block {username}?',
    muteSuccess: 'The user has been blocked.',
    unmuteConfirm: 'Are you sure to unblock {username}?',
    unmuteSuccess: 'Unblocked',
    promoteConfirm: 'Are you sure to set {username} as your channel\'s Admin?',
    promoteSuccess: '{username} has been set as the Admin',
    demoteConfirm: '{username} once removed will no longer be your live channel\'s Admin. Are you sure to proceed?',
    demoteSuccess: 'Removed',
  },
  chargeStrip: {
    tabProgress: 'Total Charging',
    consumeStar: 'Consume Stars or complete tasks to win energy points and participate in energy bar lucky draw',
    // eslint-disable-next-line max-len
    consumeReward: 'For each Star you spend in a livestreaming channel, you can add 1 energy point to the energy bars of the channel and BiliBili.',
    followRoom: 'Follow the channel',
    followRoomAward: 'Add 3 energy points to the energy bars of the followed channel and BiliBili',
    sendDanmaku: 'Send 1 Danmaku in a livestreaming channel today',
    sendDanmakuAward: 'Add 1 energy point to the energy bars of the channel and BiliBili',
    watchLive10M: 'Watch live videos in a single channel for a total of 10 minutes',
    watchLive10MAward: 'Add 1 energy point to the energy bars of the channel and BiliBili',
    watchLive30M: 'Watch live videos in a single channel for a total of 30 minutes',
    watchLive30MAward: 'Add 3 energy points to the energy bars of the channel and BiliBili',
    watchLive120M: 'Watch live videos in a single channel for a total of 120 minutes',
    watchLive120MAward: 'Add 15 energy points to the energy bars of the channel and BiliBili',
    watchLive: 'Watch live videos in a single channel for a total of 10/30/120 minutes',
    watchLiveAward: 'Add 1/3/15 energy point to the energy bars of the channel and BiliBili',

    tabTask: 'Charging Tasks',
    uAddRoomEnergy: 'Total energy points you\'ve added to the current channel',
    uAddStationEnerygy: 'Total energy points you\'ve added to BiliBili',
    // eslint-disable-next-line max-len
    consumeStarInRoom: 'For each Star you spend in this livestreaming channel, you can add 1 energy point to the energy bars of the channel and BiliBili.',

    tabRule: 'Rules',
    ruleDesc: `Spend Stars/complete tasks for an energy bar of a LV to obtain energy points.
    When the energy bar is full, you can participate in the energy bar lucky draw of the corresponding LV.
    For your prize details, go to Winning Records in the upper right corner.`,
    prizesBoth: 'Prizes corresponding to livestreaming channel/BiliBili energy bars:',
    prizeRoom: 'Livestreaming channel energy bar',
    prizeStation: 'BiliBili energy bar',
    avatarFrames: 'Avatar frames',
    premium: 'BiliBili Premium',
    winningRecords: 'Winning records'
  },
  blindBoxAward: {
    title: 'Reward Record',
    stars: 'Rewards(Stars)',
    send: 'Sent',
    andWon: 'and won',
    to: 'To',
    noReward: 'No reward record',
  }
};

export default en;
